import React, {Fragment, useState, useEffect} from "react";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {Redirect} from "react-router-dom";

const FormModal = (props) => {

    const {sitePrefix} = props;
    const [modal, setModal] = useState(null);
    const [redirect, setRedirect] = useState(null);

    const closeModal = () => {
        if(props.renderModal === true) {
            setRedirect(sitePrefix);
            setModal(false);
            return;
        }
        setModal(!modal);
    }

    useEffect(() => {
        if(props.renderModal === true && modal === null) {
            setModal(true);
        }
    },[props.renderModal, modal]);

    if (!!redirect) {
        return <Redirect to={redirect}/>;
    }
    return (
        <Fragment>

            <ModalButton
                toggle={closeModal}
                btnText={props.btnText}
            />
            <Modal
                isOpen={modal}
                toggle={closeModal}
                className={props.className + " modal-dialog-centered"}
                size="lg"
                backdrop="static"
            >
                <ModalHeader toggle={closeModal}>
                    {props.formTitle || "No title"}
                </ModalHeader>
                <ModalBody>{React.cloneElement(props.formContent, {closeModal: closeModal, setModal: setModal})}</ModalBody>
            </Modal>
        </Fragment>
    );
};

export default FormModal;

const ModalButton = (props) => {
    return (
        <Fragment>
            <span className="d-lg-none offer_text d-none" onClick={props.toggle}> {props.btnText}</span>
            <Button id="modal-button" className="btn offer_btn"
                    onClick={props.toggle}>{props.btnText}
            </Button>
        </Fragment>
    );

}
